export default __webpack_public_path__ + "static/media/dog.de89f5d6.jpg";